import { useEffect } from 'react';

type UseSafeRequestProps<TParams, TResponse> = {
  request: (params: TParams) => Promise<TResponse>;
  params: TParams;
  options?: {
    deps?: any[];
    reset?: () => void;
    pulling?: {
      callBack: (params: any) => any | Promise<any>;
      callBackParams: any;
      timestamp: number;
    }
  }
};

function useSafeRequest<TParams, TResponse>({
  request,
  params,
  options,
}: UseSafeRequestProps<TParams, TResponse>) {
  useEffect(() => {
    const abortController = new AbortController();

    let intervalId: ReturnType<typeof setInterval> | undefined;

    request({ ...params, signal: abortController.signal });

    if (options?.pulling) {
      intervalId = setInterval(() => options.pulling.callBack({ ...options.pulling.callBackParams, signal: abortController.signal }), options.pulling.timestamp);
    }

    return () => {
      options?.reset?.();
      if (intervalId) clearInterval(intervalId);
      abortController.abort();
    };
  }, options?.deps || []);
}

export default useSafeRequest;
